// extracted by mini-css-extract-plugin
export var typingIndicator = "_lo-0";